<template>
  <div id="calculator-tab">
    <div class="row">
      <div class="col s6 ">
        <div class="card indigo accent-2 hoverable">
          <div class="card-content white-text">
            <div class="card-title">Essential Household Needs Calculator</div>
          </div>
          <div class="card-action">
            <button
              @click="$_openCalculator('non')"
              class="btn btn-rounded white grey-text text-darken-4 waves-effect"
            >OPEN</button>
          </div>
        </div>
      </div>
      <div class="col s6 ">
        <div class="card hoverable">
          <div class="card-content ">
            <div class="card-title">Non Essential Household Needs Calculator</div>
          </div>
          <div class="card-action">
            <button
              @click="$_openCalculator('essential')"
              class="btn btn-rounded grey darken-1 waves-effect"
            >OPEN</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "CalculatorTab",
  props: {},
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {
    //   ...mapActions("Main","")
    $_openCalculator(calculator) {
      // calculator should be essential to open essential household needs calculator
      // calculator should be non to open non essential household needs calculator
      // calculator should be energy to open energy calculator
      this.$store.dispatch("Main/setShowCalculator", calculator);
    },
  },
};
</script>
<style lang="scss" scoped>
#calculator-tab {
  padding: 8px 0 0 0;
  .card {
    border-radius: 9px;
    overflow: hidden;
    .card-title {
      font-size: 20px;
      margin-bottom: 6px;
      line-height: 22px;
    }
  }
}
</style>
